import type { PropsWithChildren } from 'react'

import { Icon } from '@fv/client-components'

import { Help } from '@/components/Help'

import { calculateFreightClassEstimate } from './freight-class'

type Props = {
  containerClassName?: string
  height?: number
  length?: number
  quantity?: number
  weight?: number
  width?: number
  densityCalculationOnly?: boolean
}

export const FreightClassEstimate = ({
  children,
  ...props
}: PropsWithChildren<Props>) => {
  const estimate = calculateFreightClassEstimate(props)
  if (!estimate) return children
  const { freightClass, density, volume } = estimate

  const classEstimate = (
    <div className="bg-fv-blue-50 px-4 py-3 border border-fv-blue-200 relative">
      <div className="flex items-center">
        <span>
          <Icon icon="calculator" className="text-fv-gray-dark" />
          <span>=</span>
        </span>
        <span className="ml-2">
          {volume} cu ft @ {density} lbs. per cu ft
        </span>
        {!props.densityCalculationOnly && (
          <span className="ml-auto flex items-center">
            <span>Class</span>
            <span className="ml-2 text-[1.4rem]">{freightClass} </span>
            <Help className="ml-1">
              Freightview is only estimating this class based on density. There
              are other factors that can influence freight class. We are not
              responsible for freight discrepancies. Use as a recommendation
              only.
            </Help>
          </span>
        )}
      </div>
    </div>
  )

  if (props.containerClassName) {
    return <div className={props.containerClassName}>{classEstimate}</div>
  }

  return classEstimate
}
